export default __webpack_public_path__ + "static/media/student-img.074aca0b.webp";